/* unplugin-vue-components disabled */import { render } from "./AIChapterContentGenerator.vue?vue&type=template&id=c3ecd2b0&scoped=true&ts=true"
import script from "./AIChapterContentGenerator.vue?vue&type=script&lang=ts"
export * from "./AIChapterContentGenerator.vue?vue&type=script&lang=ts"

import "./AIChapterContentGenerator.vue?vue&type=style&index=0&id=c3ecd2b0&lang=scss"
import "./AIChapterContentGenerator.vue?vue&type=style&index=1&id=c3ecd2b0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3ecd2b0"]])

export default __exports__